"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.archiveMultiCurrency = exports.setMultiCurrency = exports.fetchMultiCurrencies = exports.setCompanyCurrency = exports.fetchMultiCurrencyCodes = exports.fetchCompanyCurrency = exports.fetchMultiCurrencyActive = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _getEarlyRequesterResultPromise = _interopRequireDefault(require("../getEarlyRequesterResultPromise"));

var BASE_URI = '/multi-currency/v1/currencies';

var fetchMultiCurrencyActive = function fetchMultiCurrencyActive() {
  return (0, _getEarlyRequesterResultPromise.default)('multicurrency') || _apiClient.default.get(BASE_URI + "/information", {
    query: {
      portalId: _hubspot.default.get()
    }
  });
};

exports.fetchMultiCurrencyActive = fetchMultiCurrencyActive;

var fetchCompanyCurrency = function fetchCompanyCurrency() {
  return _apiClient.default.get(BASE_URI + "/home-currency", {
    query: {
      portalId: _hubspot.default.get()
    }
  });
};

exports.fetchCompanyCurrency = fetchCompanyCurrency;

var fetchMultiCurrencyCodes = function fetchMultiCurrencyCodes() {
  return _apiClient.default.get(BASE_URI + "/currency-codes", {
    query: {
      portalId: _hubspot.default.get()
    }
  });
};

exports.fetchMultiCurrencyCodes = fetchMultiCurrencyCodes;

var setCompanyCurrency = function setCompanyCurrency(_ref) {
  var companyCurrencyCode = _ref.companyCurrencyCode,
      updatedCurrencyExchangeRates = _ref.updatedCurrencyExchangeRates;
  return _apiClient.default.post(BASE_URI + "/home-currency?portalId=" + _hubspot.default.get(), {
    data: {
      homeCurrencyCode: companyCurrencyCode,
      updatedCurrencyExchangeRates: updatedCurrencyExchangeRates
    }
  });
};

exports.setCompanyCurrency = setCompanyCurrency;

var fetchMultiCurrencies = function fetchMultiCurrencies() {
  return _apiClient.default.get(BASE_URI, {
    query: {
      portalId: _hubspot.default.get()
    }
  });
};

exports.fetchMultiCurrencies = fetchMultiCurrencies;

var setMultiCurrency = function setMultiCurrency(_ref2) {
  var fromCurrencyCode = _ref2.fromCurrencyCode,
      toCurrencyCode = _ref2.toCurrencyCode,
      conversionMultiplier = _ref2.conversionMultiplier;
  return _apiClient.default.post(BASE_URI + "/exchange-rates?portalId=" + _hubspot.default.get(), {
    data: {
      fromCurrencyCode: fromCurrencyCode,
      toCurrencyCode: toCurrencyCode,
      conversionMultiplier: conversionMultiplier
    }
  });
};

exports.setMultiCurrency = setMultiCurrency;

var archiveMultiCurrency = function archiveMultiCurrency(_ref3) {
  var fromCurrencyCode = _ref3.fromCurrencyCode,
      toCurrencyCode = _ref3.toCurrencyCode;
  return _apiClient.default.delete(BASE_URI + "/exchange-rates/" + fromCurrencyCode + "/" + toCurrencyCode + "/?portalId=" + _hubspot.default.get());
};

exports.archiveMultiCurrency = archiveMultiCurrency;